import { As, Box, Icon, Stack } from '@chakra-ui/react';
import { FC } from 'react';

export interface StepRulerProps {
  icon?: As;
}

export const StepRuler: FC<StepRulerProps> = ({ icon }) => {
  const rulerColor = 'brand.secondary.swatch4';
  return (
    <Stack direction="column" align="center" spacing={1}>
      <Box bgColor={rulerColor} w="2px" h={4} />
      <Icon as={icon} boxSize={6} color={rulerColor} />
      <Box bgColor={rulerColor} w="2px" h="full" />
    </Stack>
  );
};
